import { AuthenticationServiceTokens } from '@/authentication/di-tokens';
import type { JWT } from '@/authentication/services/interfaces';
import type { SessionContainer } from '@/authentication/session/session-container';
import { baseContainer } from '@/di/container';

export const getSessionContainer = () =>
    baseContainer.resolve<SessionContainer<JWT>>(AuthenticationServiceTokens.SessionContainer);
